import { SpaceVertical } from "../../../common/utils/spacing";
import "./contact.css";
import { PhoneOutlined, MailOutlined } from "@ant-design/icons";
import { Button, Form, Input, Result } from "antd";
import { useState } from "react";
import emailjs from "@emailjs/browser";
import TextArea from "antd/lib/input/TextArea";

export const ContactMobile = () => {
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const sendEmail = (values) => {
    setSending(true);
    emailjs
      .send("service_sk5xfye", "template_gk7zcar", values, "cW0kTgMmXhntnO3fh")
      .then(
        function (response) {
          setSuccess(true);
          setSending(false);

          console.log("SUCCESS!", response.status, response.text);
        },
        function (error) {
          console.log("FAILED...", error);
          setSending(false);
        }
      );
  };

  return (
    <div className="m-contact">
      {!success ? (
        <>
          <h1 className="title"> CONTACTEZ-MOI</h1>
          <p className="subtitle">
            Merci de l'intérêt que vous portez a mon profile. Veuillez utiliser
            ce formulaire pour nous contacter. Réponse rapide assurée !
          </p>
          <SpaceVertical size={25} />

          <div className="m-contact-content">
            <div className="list-icon-text">
              <div>
                <PhoneOutlined />
                <span>| +221 78 139 22 17</span>
              </div>
              <SpaceVertical size={5} />
              <div>
                <MailOutlined />
                <span className="mail">| dialllohali2017@gmail.com</span>
              </div>
            </div>
            <SpaceVertical size={25} />

            <Form
              name="basic"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 16,
              }}
              initialValues={{
                remember: true,
              }}
              onFinish={sendEmail}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              disabled={sending}
            >
              <Form.Item
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "SVP Donnez votre Prenom",
                  },
                ]}
              >
                <Input size="large" placeholder="Prenom" />
              </Form.Item>

              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    message: "SVP Donnez votre E-mail",
                    type: "email",
                  },
                ]}
              >
                <Input size="large" placeholder="E-mail" />
              </Form.Item>

              <Form.Item name="phone">
                <Input size="large" placeholder="Telephone" />
              </Form.Item>

              <Form.Item
                name="message"
                rules={[
                  {
                    required: true,
                    message: "SVP Entrez votre message",
                  },
                ]}
              >
                <TextArea rows={4} placeholder="Redigez votre message" />
              </Form.Item>

              <Button
                type="primary"
                className="btn-submit"
                size="large"
                style={{ float: "right" }}
                htmlType="submit"
                loading={sending}
              >
                Envoyer
              </Button>
            </Form>
          </div>
        </>
      ) : (
        <Result
          status="success"
          title="Message envoyé avec succès !"
          extra={[
            <Button
              type="primary"
              onClick={() => {
                setSuccess(false);
              }}
            >
              RETOUR
            </Button>,
          ]}
        />
      )}
    </div>
  );
};
